var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.50007C9.91166 2.49882 9.82395 2.51514 9.74197 2.54808C9.65999 2.58102 9.58538 2.62993 9.52247 2.69196C9.45955 2.75399 9.4096 2.8279 9.3755 2.90941C9.3414 2.99091 9.32384 3.07838 9.32384 3.16673C9.32384 3.25508 9.3414 3.34255 9.3755 3.42406C9.4096 3.50556 9.45955 3.57948 9.52247 3.64151C9.58538 3.70354 9.65999 3.75244 9.74197 3.78539C9.82395 3.81833 9.91166 3.83465 10 3.8334C13.6897 3.8334 16.6667 6.81038 16.6667 10.5001C16.6667 14.1898 13.6897 17.1667 10 17.1667C6.31031 17.1667 3.33333 14.1898 3.33333 10.5001C3.33333 8.93356 3.87236 7.49796 4.77344 6.36205L6 7.8334L7.33333 3.16673L2.66667 3.8334L3.91146 5.32689C2.72444 6.72344 2 8.52793 2 10.5001C2 14.9104 5.58969 18.5001 10 18.5001C14.4103 18.5001 18 14.9104 18 10.5001C18 6.08976 14.4103 2.50007 10 2.50007Z",
    fill: "#474B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.f2c465983761b2e319a6150f5205d5f0.svg";
export { ForwardRef as ReactComponent };